export enum TABS_DATA_HOOKS {
  leftNavButton = 'left-nav-btn',
  rightNavButton = 'right-nav-btn',
  scrollableTabs = 'scrollable-tabs',
  tab = 'tab-item',
}

export enum TABS_DATA_KEYS {
  alignment = 'data-alignment',
  variant = 'data-variant',
  skin = 'data-skin',
  navButtons = 'data-navbuttons',
  mobile = 'data-mobile',
  rtl = 'data-rtl',
  tabIndex = 'data-tab-index',
  tabIsActive = 'data-tab-active',
}
